import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './screen/Home';
import Createblogbyuser from './screen/Createblogbyuser';
import Updatepost from './screen/Updatepost';
import Singlepost from './screen/Singlepost';



function App() {
  return (
    <Router>
    <div>
    <Routes>
     <Route exact path='/' element={<Home/>}/>
     <Route exact path='/Createblogbyuser' element={<Createblogbyuser/>}/>
     <Route exact path="/updatepost/:postId"  element={<Updatepost/>}/>
     <Route exact path="/singlepost/:postId"  element={<Singlepost/>}/>
    </Routes>      
    </div>
    </Router>
  );
}

export default App;
